/* ============================================================
   バターサンド総選挙 2026 — 投票フォームのクライアント
   （sections/buttersand-election.liquid と対。保存先は GAS の ButterSandElection.gs）

   ■ 一番大事なこと
     「投票できたように見えて、保存されていない」状態を作らない。
       - ページ表示時に electionStatus を問い合わせる。ok が返るまでフォームは出さない。
       - 送信は返事を読める方法（CORS付き fetch）だけ。no-cors は使わない。
       - サーバーが accepted を返したときだけ完了画面を出す。

   ■ 誤タップ対策
     「この味に投票する」→ 確認（候補名とメールアドレスを大きく表示）→「投票を確定する」の2段階。

   ■ 二重送信
     送信中はボタンを止める。request_id は成功するまで同じ値を使い回すので、
     通信が切れて再送してもサーバー側で1票にまとまる。

   ■ 流入元（src）
     URL の ?src=store などを保存する。無ければ direct。
     同じタブで最初に付いていた値を sessionStorage に覚えておき、
     途中でパラメータが消えても引き継ぐ。utm_* は一緒に送るだけで、あっても無くても壊れない。

   ■ CORS
     Content-Type: text/plain で POST する（application/json だと preflight が飛び、GAS が応えない）。

   ■ お知らせメールの同意（任意・初期オフ）
     チェックの状態を marketing_opt_in（真偽値）で一緒に送る。チェックしていなければ false。
     投票の可否とは独立していて、サーバーは「すでに投票済み」でもチェックがあれば同意だけ記録する。
     確認画面に「お知らせメール：受け取る／受け取らない」を出し、本人が選んだ内容を確かめてから送る。
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-bse]');
  if (!root) return;

  var endpoint = (root.getAttribute('data-endpoint') || '').trim();
  var form = root.querySelector('[data-bse-form]');
  var statusEls = root.querySelectorAll('[data-bse-status]');
  var totalEl = root.querySelector('[data-bse-total]');
  var errorsEl = root.querySelector('[data-bse-errors]');
  var selectedEl = root.querySelector('[data-bse-selected]');
  var confirmEl = root.querySelector('[data-bse-confirm]');
  var confirmErrors = root.querySelector('[data-bse-confirm-errors]');
  var sendBtn = root.querySelector('[data-bse-send]');
  var doneEl = root.querySelector('[data-bse-done]');
  var optinEl = root.querySelector('[data-bse-optin]');
  var confirmOptin = root.querySelector('[data-bse-confirm-optin]');
  var doneOptin = root.querySelector('[data-bse-done-optin]');

  var STORE_SRC = 'cc3Bse2026Src';
  var STORE_DONE = 'cc3Bse2026Done';
  var TIMEOUT_MS = 20000;

  var ticket = '';
  var ticketAt = 0;
  var serverNow = 0;          // GAS が返した時刻（ミリ秒）。結果発表の判定に使う
  var requestId = '';
  var inFlight = false;

  /* ---------- 小物 ---------- */

  function ss(action, key, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(key);
      if (action === 'set') window.sessionStorage.setItem(key, value);
      if (action === 'del') window.sessionStorage.removeItem(key);
    } catch (e) { /* プライベートブラウズなど。覚えられなくても投票はできる */ }
    return null;
  }

  function track(name, params) {
    /* 計測タグは足さない。既に dataLayer があるときだけ流す（竜王イベントと同じ方針）。 */
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: 'bse_' + name }, params || {}));
      }
    } catch (e) { /* noop */ }
  }

  function setStatus(text, isError) {
    statusEls.forEach(function (el) {
      el.textContent = text || '';
      el.classList.toggle('bse-status--error', !!isError);
    });
  }

  function showErrors(el, messages) {
    if (!el) return;
    el.innerHTML = '';
    (messages || []).forEach(function (m) {
      var li = document.createElement('li');
      li.textContent = m;
      el.appendChild(li);
    });
  }

  function setPhase(phase) {
    root.setAttribute('data-phase', phase);
  }

  function newRequestId() {
    try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID(); } catch (e) { /* noop */ }
    return 'r-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function normalizeEmail(v) {
    var s = String(v || '');
    try { s = s.normalize('NFKC'); } catch (e) { /* noop */ }
    return s.trim().toLowerCase();
  }

  /* サーバー（bseValidEmail_）と同じ判定。 */
  function validEmail(email) {
    if (!email || email.length > 254 || /^[+\-]/.test(email)) return false;
    return /^[a-z0-9._%+\-]+@[a-z0-9\-]+(\.[a-z0-9\-]+)*\.[a-z]{2,}$/.test(email);
  }

  /* ---------- 流入元 ---------- */

  function cleanSource(v) {
    return String(v || '').trim().toLowerCase().replace(/[^a-z0-9_\-]/g, '').slice(0, 32);
  }

  function context() {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var get = function (k) { return params ? (params.get(k) || '') : ''; };

    var src = cleanSource(get('src'));
    if (src) ss('set', STORE_SRC, src);
    else src = cleanSource(ss('get', STORE_SRC)) || 'direct';

    return {
      source: src,
      utm_source: get('utm_source').slice(0, 100),
      utm_medium: get('utm_medium').slice(0, 100),
      utm_campaign: get('utm_campaign').slice(0, 100),
      user_agent: (navigator.userAgent || '').slice(0, 200)
    };
  }

  /* ---------- サーバー ---------- */

  function call(action, payload) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, TIMEOUT_MS) : null;
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ action: action, payload: payload || {} }),
      redirect: 'follow',
      cache: 'no-store',
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      if (timer) clearTimeout(timer);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }, function (err) {
      if (timer) clearTimeout(timer);
      throw err;
    }).then(function (res) {
      if (!res || res.ok !== true || !res.data) throw new Error((res && res.error) || 'unexpected response');
      var at = Date.parse(res.at || '');
      if (!isNaN(at)) serverNow = at;
      return res.data;
    });
  }

  var UNAVAILABLE = 'ただいま投票を受け付けられません。時間をおいて、もう一度ページを開いてください。';

  function applyStatus(s) {
    ticket = s.ticket || '';
    ticketAt = Date.now();
    if (totalEl) {
      if (typeof s.total_votes === 'number') {
        totalEl.textContent = '現在 ' + s.total_votes.toLocaleString('ja-JP') + ' 票';
        totalEl.hidden = false;
      } else {
        totalEl.hidden = true;
      }
    }
    if (root.getAttribute('data-phase') === 'done') return;

    if (s.phase === 'open') {
      setPhase('open');
      setStatus('');
      /* 確認の途中で整理券を取り直した場合は、確認画面のままにする */
      if (confirmEl.hidden) form.hidden = false;
      track('ready');
    } else {
      setPhase(s.phase === 'before' || s.phase === 'closed' || s.phase === 'paused' ? s.phase : 'error');
      form.hidden = true;
      confirmEl.hidden = true;
      var msg = (s.phase === 'before' && beforeMessage(s.start)) || s.message || UNAVAILABLE;
      var note = root.getAttribute('data-result-note') || '';
      if (s.phase === 'closed' && note && root.getAttribute('data-result-shown') !== 'true') msg += '\n' + note;
      setStatus(msg);
    }
    watchResult();
  }

  /* ---------- 結果発表の時刻合わせ ----------
     結果はサーバー側（Liquid）で公開日時を過ぎたときだけ HTML に入る。1位の名前は JS に渡していない。
     ただし 18:00 より前に作られたページのキャッシュが配られることがあるので、
     「公開準備ができている」「まだ表示されていない」「公開日時を過ぎた」がそろったら、
     キャッシュを避けて1回だけ読み込み直す。時刻は GAS の時刻（なければ端末の時刻）で判断する。 */
  var resultTimer = null;
  function watchResult() {
    if (resultTimer) return;
    if (root.getAttribute('data-result-ready') !== 'true' || root.getAttribute('data-result-shown') === 'true') return;
    var at = parseInt(root.getAttribute('data-result-at'), 10) * 1000;
    if (!at) return;
    var now = serverNow || Date.now();
    var wait = at - now;
    if (wait > 24 * 60 * 60 * 1000) return;              // 1日以上先なら待たない（開き直したときに判断）
    resultTimer = setTimeout(reloadForResult, Math.max(0, wait) + 1500);
  }
  function reloadForResult() {
    var key = 'cc3Bse2026ResultReload';
    if (ss('get', key)) return;                           // 無限に読み込み直さない
    ss('set', key, '1');
    var u = new URL(window.location.href);
    u.searchParams.set('r', String(Math.floor(Date.now() / 60000)));
    window.location.replace(u.toString());
  }

  /* 開始前の案内は、サーバーが返した開始日時（日本時間 "2026-10-01 00:00:00"）から
     「投票は10月1日 0:00から始まります。」を組み立てる。0:00 と時刻まで出すため。
     形式が読めなければ null を返し、サーバーの文面をそのまま使う。 */
  function beforeMessage(start) {
    var m = String(start || '').match(/^\d{4}-(\d{2})-(\d{2}) (\d{2}):(\d{2})/);
    if (!m) return null;
    return '投票は' + Number(m[1]) + '月' + Number(m[2]) + '日 ' + Number(m[3]) + ':' + m[4] + 'から始まります。';
  }

  function loadStatus() {
    return call('electionStatus', {}).then(applyStatus, function () {
      if (root.getAttribute('data-phase') === 'done') return;
      setPhase('error');
      form.hidden = true;
      confirmEl.hidden = true;
      setStatus(UNAVAILABLE, true);
      watchResult();
    });
  }

  /* ---------- 選択 ---------- */

  function selectedInput() {
    return form.querySelector('input[name="choice"]:checked');
  }

  function syncSelection() {
    var input = selectedInput();
    var key = input ? input.value : '';
    root.querySelectorAll('[data-bse-pick]').forEach(function (btn) {
      var on = btn.getAttribute('data-bse-pick') === key;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-bse-pick-label]');
      if (label) label.textContent = on ? '選択中' : 'この味を選ぶ';
    });
    root.querySelectorAll('.bse-card').forEach(function (card) {
      card.classList.toggle('is-selected', card.getAttribute('data-bse-key') === key);
    });
    if (selectedEl) {
      selectedEl.textContent = input ? '選択中：' + input.getAttribute('data-label') : 'フレーバーを1つ選んでください';
      selectedEl.classList.toggle('is-on', !!input);
    }
  }

  function pick(key) {
    var input = form.querySelector('input[name="choice"][value="' + key + '"]');
    if (!input) return;
    input.checked = true;
    syncSelection();
    showErrors(errorsEl, []);
    var target = root.querySelector('#bse-vote');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    track('pick', { choice: key });
  }

  /* ---------- 送信 ---------- */

  var pending = null;

  function onSubmit(e) {
    e.preventDefault();
    if (inFlight) return;
    var input = selectedInput();
    var email = normalizeEmail(form.elements.email.value);
    var errors = [];
    if (!input) errors.push('投票するフレーバーを選んでください。');
    if (!email) errors.push('メールアドレスを入力してください。');
    else if (!validEmail(email)) errors.push('メールアドレスの形式が正しくありません。');
    showErrors(errorsEl, errors);
    if (errors.length) {
      errorsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    pending = {
      choice: input.value, label: input.getAttribute('data-label'), email: email,
      optIn: !!(optinEl && optinEl.checked === true)
    };
    root.querySelector('[data-bse-confirm-name]').textContent = pending.label;
    root.querySelector('[data-bse-confirm-email]').textContent = email;
    if (confirmOptin) confirmOptin.textContent = 'お知らせメール：' + (pending.optIn ? '受け取る' : '受け取らない');
    showErrors(confirmErrors, []);
    form.hidden = true;
    confirmEl.hidden = false;
    confirmEl.focus({ preventScroll: true });
    confirmEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function backToForm() {
    if (inFlight) return;
    confirmEl.hidden = true;
    form.hidden = false;
    var picked = selectedInput();
    (picked || form.querySelector('input[name="choice"]')).focus({ preventScroll: true });
  }

  function setSending(on) {
    inFlight = on;
    sendBtn.disabled = on;
    root.querySelector('[data-bse-back]').disabled = on;
    sendBtn.textContent = on ? '送信しています…' : '投票を確定する';
  }

  /* サーバーは整理券の発行から3秒未満の送信を弾く（ボット対策）。
     人が素早く押した場合はエラーにせず、足りない分だけ待ってから送る。 */
  var MIN_TICKET_AGE_MS = 3500;

  function onSend() {
    if (inFlight || !pending) return;
    if (!requestId) requestId = newRequestId();
    setSending(true);
    showErrors(confirmErrors, []);
    track('submit', { choice: pending.choice });
    var wait = Math.max(0, MIN_TICKET_AGE_MS - (Date.now() - ticketAt));
    setTimeout(send, wait);
  }

  /* 「すでに投票済み」のときの文面。チェックがあった場合は、同意を受け付けたかどうかも伝える。 */
  function alreadyMessage(d) {
    var base = d.message || 'このメールアドレスではすでに投票済みです。';
    if (d.marketing === 'recorded') return base + 'お知らせメールのご登録は受け付けました。';
    if (d.marketing === 'already') return base + 'お知らせメールのご登録は受付済みです。';
    if (d.marketing === 'busy') return base + 'お知らせメールのご登録は、混み合っているため受け付けられませんでした。時間をおいてお試しください。';
    return base;
  }

  function send() {
    var payload = Object.assign({
      choice: pending.choice,
      email: pending.email,
      ticket: ticket,
      request_id: requestId,
      website: form.elements.website ? form.elements.website.value : '',
      marketing_opt_in: pending.optIn === true,
      consent_text_version: optinEl ? (optinEl.getAttribute('data-consent-version') || '') : ''
    }, context());

    call('electionVote', payload).then(function (d) {
      setSending(false);
      if (d.result === 'accepted') {
        finish(d.choice_label || pending.label, d.marketing);
        track('complete', { choice: pending.choice, optin: pending.optIn === true });
        return;
      }
      if (d.result === 'already_voted') {
        showErrors(confirmErrors, [alreadyMessage(d)]);
        track('error', { result: d.result, optin: pending.optIn === true });
        return;
      }
      if (d.result === 'closed') {
        confirmEl.hidden = true;
        applyStatus({ phase: d.phase, message: d.message });
        return;
      }
      if (d.result === 'retry') {
        /* 整理券の期限切れなど。新しい整理券を取り直して、もう一度押してもらう。 */
        loadStatus();
      }
      showErrors(confirmErrors, [d.message || '投票を保存できませんでした。']);
      track('error', { result: d.result });
    }, function (err) {
      setSending(false);
      var offline = err && (err.name === 'AbortError' || /fetch|network|load/i.test(String(err.message)));
      showErrors(confirmErrors, [
        offline
          ? '通信に失敗しました。電波の良い場所で、もう一度「投票を確定する」を押してください。'
          : '投票を保存できませんでした。時間をおいて、もう一度お試しください。'
      ]);
      track('error', { result: 'network' });
    });
  }

  function finish(label, marketing) {
    requestId = '';
    pending = null;
    setPhase('done');
    form.hidden = true;
    confirmEl.hidden = true;
    root.querySelector('[data-bse-done-choice]').textContent = label ? '「' + label + '」に投票しました。' : '';
    if (doneOptin) {
      var optinOk = marketing === 'recorded' || marketing === 'already';
      doneOptin.textContent = optinOk ? 'お知らせメールのご登録も受け付けました。' : '';
      doneOptin.hidden = !optinOk;
    }
    doneEl.hidden = false;
    setStatus('');
    ss('set', STORE_DONE, label || '1');
    doneEl.focus({ preventScroll: true });
    doneEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* 完了画面から、同じ端末で別の人が投票する（家族など）。重複はサーバーが止める。 */
  function again() {
    ss('del', STORE_DONE);
    doneEl.hidden = true;
    if (doneOptin) { doneOptin.hidden = true; doneOptin.textContent = ''; }
    form.reset();                               // お知らせのチェックも初期状態（オフ）に戻る
    syncSelection();
    setPhase('loading');
    setStatus('受付状況を確認しています…');
    loadStatus().then(function () {
      if (!form.hidden) form.querySelector('input[name="choice"]').focus({ preventScroll: true });
    });
  }

  /* ---------- 初期化 ---------- */

  form.addEventListener('submit', onSubmit);
  form.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'choice') { syncSelection(); showErrors(errorsEl, []); }
  });
  root.querySelectorAll('[data-bse-pick]').forEach(function (btn) {
    btn.addEventListener('click', function () { pick(btn.getAttribute('data-bse-pick')); });
  });
  sendBtn.addEventListener('click', onSend);
  root.querySelector('[data-bse-back]').addEventListener('click', backToForm);
  root.querySelector('[data-bse-again]').addEventListener('click', again);

  syncSelection();

  /* 同じタブで投票を済ませていたら、再読み込みしても完了画面のまま。 */
  var doneLabel = ss('get', STORE_DONE);
  if (doneLabel) {
    setPhase('done');
    doneEl.hidden = false;
    root.querySelector('[data-bse-done-choice]').textContent =
      doneLabel !== '1' ? '「' + doneLabel + '」に投票済みです。' : '';
  }

  if (!endpoint) {
    if (!doneLabel) {
      setPhase('unconfigured');
      setStatus('投票の受付は準備中です。');
    }
    return;
  }

  if (!doneLabel) setStatus('受付状況を確認しています…');
  loadStatus();
})();
